<template>
  <div class="ma-0 pa-0">
    <!-- DESKTOP -->
    <VContainer fluid class="d-none d-lg-block py-16 ma-0 pa-0">
      <VContainer fluid class="ma-0 pa-0">
        <div class="text-center">
          <VCard class="elevation-0 transparent mt-n12" style="margin: auto;">
            <!-- truque: envolvemos a imagem num div para aplicar o border-image -->
            <div
              class="author-frame"
              style="display:inline-block; border-image: linear-gradient(#0000 25%, #29334B 0 75%, #0000 0) fill 0 / / 0 100vw;"
            >
              <VImg
                :src="Author"
                contain
                height="300"
                width="450"
                alt="Author image"
              />
            </div>
          </VCard>
        </div>
      </VContainer>

      <div class="center-div">
        <VCard class="elevation-0 mt-16">
          <VCardTitle class="text-h4 wrap-title">
            {{ Title }}
          </VCardTitle>

          <VCardSubtitle class="text-h6" style="word-break: keep-all;">
            {{ SubTitle }}
          </VCardSubtitle>

          <VCardSubtitle class="text-body-2">
            ({{ DataCreation }})
          </VCardSubtitle>

          <VCardText class="text-justify text-body-1" v-html="TextBody" />

          <VCardActions>
            <VRow class="w-100">
              <VCol cols="12" md="6" class="text-start">
                <VRow class="ml-2" align="center" no-gutters>
                  <VCol cols="auto" class="ma-0 pa-0">
                    <VAvatar size="40">
                      <VImg :src="AuthorPhoto" :alt="AuthorName" />
                    </VAvatar>
                  </VCol>

                  <VCol cols="auto" class="ma-0 pa-0">
                    <div class="ml-2">
                      <span class="font-weight-bold">{{ AuthorName }}</span>
                        <VBtn
                            v-if="Linkedin"
                            icon
                            variant="text"
                            class="social-btn ml-n1"
                            :href="Linkedin"
                            target="_blank"
                            rel="noopener"
                            aria-label="LinkedIn"
                            >
                            <VIcon icon="mdi-linkedin" />
                        </VBtn>
                    </div>
                  </VCol>
                </VRow>
              </VCol>

              <VCol cols="12" md="6" class="text-end">
                <VBtn
                  color="warning"
                  variant="elevated"
                  @click="$router.push('/' + $i18n.locale + '/article/' + ID)"
                >
                   <span style="color:#fff"><VIcon class="mr-2" icon="mdi-eye" />
                  {{ $t('buttons.look') }}</span>
                </VBtn>
              </VCol>
            </VRow>
          </VCardActions>
        </VCard>
      </div>
    </VContainer>

    <!-- MOBILE -->
    <VContainer fluid class="d-md-none">
      <VContainer fluid>
        <VCard class="elevation-24" style="margin: auto;">
          <VImg :src="Author" alt="Author image" contain />
        </VCard>
      </VContainer>

      <div class="center-div">
        <VCard class="elevation-0 mt-16">
          <VCardTitle class="text-h6 wrap-title">{{ Title }}</VCardTitle>

          <VCardSubtitle class="text-body-1">{{ SubTitle }}</VCardSubtitle>

          <VCardSubtitle class="text-caption mt-n8">
            ({{ DataCreation }})
          </VCardSubtitle>

          <VCardText class="text-justify text-body-1" v-html="TextBody" />

          <VCardActions>
            <VRow class="w-100">
              <VCol cols="12" md="6" class="text-start">
                <VRow class="ml-2" align="center" no-gutters>
                  <VCol cols="auto" class="ma-0 pa-0">
                    <VAvatar size="36">
                      <VImg :src="AuthorPhoto" :alt="AuthorName" />
                    </VAvatar>
                  </VCol>

                  <VCol cols="auto" class="ma-0 pa-0">
                    <div class="ml-2">
                      <span class="font-weight-bold">{{ AuthorName }}</span>
                      <br />
                      <VBtn
                        v-if="Linkedin"
                        icon
                        variant="text"
                        class="social-btn ml-n1"
                        :href="Linkedin"
                        target="_blank"
                        rel="noopener"
                        aria-label="LinkedIn"
                        >
                        <VIcon icon="mdi-linkedin" />
                        </VBtn>
                    </div>
                  </VCol>
                </VRow>
              </VCol>

              <VCol cols="12" md="6" class="text-end">
                <VBtn
                  color="warning"
                  @click="$router.push('/' + $i18n.locale + '/article/' + ID)"
                >
                  <VIcon class="mr-2" icon="mdi-eye" />
                  {{ $t('buttons.look') }}
                </VBtn>
              </VCol>
            </VRow>
          </VCardActions>
        </VCard>
      </div>
    </VContainer>

    <VDivider />
  </div>
</template>

<script>
export default {
  name: 'ArticleCard',
  props: {
    ID: { type: String, required: true },
    Title: { type: String, required: true },
    SubTitle: { type: String, required: true },
    TextBody: { type: String, required: true },
    Author: { type: String, required: true },        // url/asset da imagem principal
    AuthorName: { type: String, required: true },
    DataCreation: { type: String, required: true },
    AuthorPhoto: { type: String, required: true },    // url/asset do avatar
    Linkedin: { type: String, default: null }
  },
  methods: {
    openSocialNetwork (social, link) {
      if (social === 'linkedin' && link) window.open(link, '_blank')
    }
  }
}
</script>

<style>
.wrap-title{
  white-space: normal !important;   /* permite múltiplas linhas */
  word-break: break-word;           /* quebra palavras longas se precisar */
  overflow-wrap: anywhere;          /* fallback extra para strings sem espaços */
}

.gb-social-button__focuser{
  border: none !important;
}

.center-div{
  margin: auto; width: 100%;
}

@media (min-width: 850px) {
  .center-div{
    margin: auto; width: 65%;
  }

  .container {
    width: 100vw;
    justify-content: center;
    position: relative;
  }

  .line-divider {
    height: 200px;
    display: flex;
    background-color: #29334B;
    align-items: center;
    position: relative;
  }

  .line {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 25px;
    z-index: -1;
    transform: translateY(-50%);
  }

  .line-divider img {
    height: 300px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  .article-photo{
    display: block;
    position: fixed;
  }
}
</style>
